export default __webpack_public_path__ + "9ce704e4ded3af35c7ef0aa78ea789cd.png";